if (!process.env.REACT_APP_INFURA_ID) {
  throw new Error(`Env variable 'REACT_APP_INFURA_ID' is missing`);
}

export const INFURA_ID = process.env.REACT_APP_INFURA_ID;
